let utils = require('../../actions/utils');
let ordersList = require('../../actions/account/orders-list');
let order = require('../../actions/order');
let account = require('../../actions/account/orders');
let user = require('../../actions/user');
let error = require('../../actions/error');
let { updateOrderData } = require('../groups/account');

let updateOrdersList = [
    ordersList.filterToLocalStorage,
    ordersList.resetPaging,
    utils.queryRedirectFromState(['account', 'orders', 'computed', 'query']),
    [
        ordersList.getOrdersList, {
        success: [
            utils.unset(['account', 'orders', 'list', 'data']),
            ordersList.addOrders,
            utils.unset(['account', 'orders', 'list', 'isNextPageLoading'])
        ],
        notFound: [
            utils.unset(['account', 'orders', 'list', 'data'])
        ],
        error: [
            utils.set(['account', 'orders', 'list', 'isError'], true)
        ]
    }
    ]
];

module.exports = {
    scrolledToBottom: [
        ordersList.checkLoadingQueue, {
            empty: [
                utils.set(['account', 'orders', 'list', 'isError'], false),
                utils.set(['account', 'orders', 'list', 'isNextPageLoading'], true),
                ordersList.incrementCurrentPage,
                [
                    ordersList.getOrdersList, {
                        success: [
                            ordersList.addOrders,
                            utils.unset(['account', 'orders', 'list', 'isNextPageLoading'])
                        ],
                        notFound: [
                        ],
                        error: [
                            utils.set(['account', 'orders', 'list', 'isError'], true)
                        ]
                    }
                ]
            ]
        }
    ],

    selectFilter: [
        [
            user.isUnauthorized,
            {
                yes: [],
                no: [
                    utils.setFromArgsToState('selectedValue', ['account', 'orders', 'list', 'selectedTypeFilter']),
                    ...updateOrdersList
                ]
            }
        ]
    ],

    togglePopup: [
        utils.togglePopupFromArgs
    ],

    setStatusFilterItem: [
        ordersList.setStatusFilterItem,
        ...updateOrdersList
    ],

    setTypeFilterItem: [
        ordersList.setTypeFilterItem,
        ...updateOrdersList
    ],

    toggleStatusFilter: [
        utils.togglePopup('statusFilter')
    ],

    updateOrdersList: [
        ...updateOrdersList
    ],

    filterOrdersListByText: [
        [
            ordersList.getActionByTextFilter,
            {
                updateWithFilter: [
                    utils.setFromArgsToState('textFilterValue', ['account', 'orders', 'list', 'filterText']),
                    ...updateOrdersList
                ],
                updateWithoutFilter: [
                    utils.unset(['account', 'orders', 'list', 'filterText']),
                    ...updateOrdersList
                ],
                none: []
            }
        ]
    ],

    checkAssigned: [
        utils.setFromArgsToState('key', ['account', 'orders', 'list', 'selectedRadioFilter']),
        ...updateOrdersList
    ],

    onCreateOrder: [
        [
            account.fillOrderTypeInSelectedParameters,
            order.createOrder,
            {
                success: [
                    utils.set(['account', 'orders', 'list', 'isAllLoaded'], false),
                    order.orderCreatedRedirect
                ],
                error: [
                    error.internalError('orders-list.onCreateOrder')
                ]
            }
        ]
    ],

    setTextFilterValue: [
        utils.setElementValue
    ],

    clearFilters: [
        utils.unset(['account', 'orders', 'list', 'filterText']),
        // очищаем html-input с текстом
        utils.setElementValueById('managerOrderTextFilter', ''),
        utils.unset(['account', 'orders', 'list', 'typeFilter']),
        utils.unset(['account', 'orders', 'list', 'stateFilter']),
        utils.set(['account', 'orders', 'list','selectedRadioFilter'], 'any'),
        ...updateOrdersList
    ],

    onLoad: [
        [
            utils.isEqual(['user', 'isManager'], true),
            {
                yes: [
                    [
                        utils.isEqual(['account', 'orders', 'shouldRestoreFilters'], true),
                        {
                            yes: [
                                ordersList.filterRestoreFromStorage
                            ],
                            no: [
                                ordersList.filterToLocalStorage
                            ]
                        }
                    ],
                    utils.setArgFromState('orderId', ['account', 'orders', 'queryOrderId']),
                    ...updateOrderData,
                    utils.queryRedirectFromState(['account', 'orders', 'computed', 'query'])
                ],
                no: []
            }
        ]
    ]
};



// WEBPACK FOOTER //
// ./signals/account/orders-list.js